import { render, staticRenderFns } from "./Binding.vue?vue&type=template&id=6796d32c&"
import script from "./Binding.vue?vue&type=script&lang=js&"
export * from "./Binding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports